import { render } from "./intellectualProperty.vue?vue&type=template&id=00f59ece&scoped=true"
import script from "./intellectualProperty.vue?vue&type=script&lang=js"
export * from "./intellectualProperty.vue?vue&type=script&lang=js"

import "./intellectualProperty.vue?vue&type=style&index=0&id=00f59ece&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f59ece"]])

export default __exports__